import { useSelectDashboardFolderModalModel } from './select-dashboard-folder-modal.model'
import type { IBaseSelectDashboardFolderModalProps } from './select-dashboard-folder-modal.types'
import { SelectDashboardFolderModalView } from './select-dashboard-folder-modal.view'

export const SelectDashboardFolderModal = ({ isOpen }: IBaseSelectDashboardFolderModalProps) => {
  const selectDashboardFolderModalModel = useSelectDashboardFolderModalModel()
  return <SelectDashboardFolderModalView isOpen={isOpen} {...selectDashboardFolderModalModel} />
}
